module.exports = __webpack_public_path__ + "img/korea-republic-logo-icon.72dd6699.png";